export const formatDate = (dateString: string, locale?: string) => {
    return new Date(dateString).toLocaleDateString(locale);
};

export const formatDateTime = (dateString: string, locale?: string) => {
    return new Date(dateString).toLocaleString(locale);
};
